import _ from 'lodash';

export default function normalize(str) {
  return _.kebabCase(_.deburr(str || '')).trim()
};
